window.onload = function () {
  const form = document.querySelector('.i_blocgenform form');
  const targets = [...document.querySelectorAll('.js-form')];
  const dropdown = [...document.querySelectorAll('[data-state]')];

  dropdown.forEach((e) => {
    e.addEventListener('click', function (e) {
      this.setAttribute(
        'data-state',
        this.getAttribute('data-state') === 'open' ? 'closed' : 'open'
      );
    });
  });

  targets.forEach((e) => {
    if (form !== null) {
      const newForm = form.cloneNode(true);
      const container = document.createElement('div');
      container.setAttribute('data-expanded', 'false');
      container.setAttribute('class', 'form__container');
      container.append(newForm);

      e.parentElement.append(container);
      e.addEventListener('click', function (e) {
        const duplicateForm =
          this.parentElement
            .querySelector('.form__container')
            .getAttribute('data-expanded') === 'true'
            ? this.parentElement
                .querySelector('.form__container')
                .setAttribute('data-expanded', false)
            : this.parentElement
                .querySelector('.form__container')
                .setAttribute('data-expanded', true);
      });
    }
  });

  const offers = ['eurocompte', 'pret_perso', 'pret_immo'];

  offers.map((el) => {
    const item = document.querySelector(`.${el}`);
    const dataType = `data-type=${el}`;
    const target = document.querySelector(`[${dataType}]`);

    item.addEventListener('click', function (e) {
      target.setAttribute(
        'data-state',
        target.getAttribute('data-state') === 'open' ? 'closed' : 'open'
      );
    });
  });

  const options = [...document.querySelectorAll('[class*=option_]')];
  options.forEach((el) => {
    const CTA = el.querySelector('a[href="#frmCreditImmo"]');
    CTA.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('cta click');
      switch (el.className) {
        case 'option_pretperso':
          form.querySelector('select').value = 'Prêt Personnel';
          break;
        case 'option_eurocompte':
          form.querySelector('select').value = 'Compte Courant';
          break;
        case 'option_pretimmo':
          form.querySelector('select').value = 'Prêt Immobilier';
          break;
        case 'option_assuauto':
          form.querySelector('select').value = 'Assurance Auto';
          break;
        case 'option_mobile':
          form.querySelector('select').value = 'Mobile et Box';
          break;
        case 'option_eco':
          form.querySelector('select').value = 'Financer un véhicule';
          break;
        case 'option_epargne':
          form.querySelector('select').value = 'Epargne';
          break;
        case 'option_alarme':
          form.querySelector('select').value = 'Alarme Maison';
          break;

        default:
          break;
      }
    });
  });
};
